import React from 'react';
import { ScrollVideo } from '../components/nova/ScrollVideo';
import { Navbar } from '../components/nova/Navbar';
import { SectionOne } from '../components/nova/SectionOne';
import { SectionTwo } from '../components/nova/SectionTwo';
export function NovaAI() {
  return <div className="relative font-nova text-white min-h-screen nova-selection" data-id="element-3812">
      <ScrollVideo data-id="element-3813" />
      <Navbar data-id="element-3814" />
      <main data-id="element-3815">
        <SectionOne data-id="element-3816" />
        <div aria-hidden className="h-[80vh]" data-id="element-3817" />
        <SectionTwo data-id="element-3818" />
      </main>
    </div>;
}